<lib-header [client]="clientApp">
  <ul class="nav navbar-nav flex-grow-1 py-4">
    @if (isLoggedIn) {
      <li
        class="nav-item"
        >
        <a
          class="nav-link"
          routerLinkActive="tab-active"
          [routerLink]="['/home']"
          >
          Home
        </a>
      </li>
    }
    @if (isLoggedIn && hasRole(roles.lenderCriteria)) {
      <li
        class="nav-item"
        >
        <a
          class="nav-link"
          routerLinkActive="tab-active"
          [routerLink]="['/criteria-v2/dashboard']"
          >
          Criteria
        </a>
      </li>
    }
    @if (isLoggedIn && hasAccessToMi) {
      <li
        class="nav-item"
        >
        <a
          class="nav-link"
          routerLinkActive="tab-active"
          [routerLink]="firstMiLink"
          >
          MI &amp; Insights
        </a>
      </li>
    }
    @if (hasRole(roles.product) && lenderHasProducts) {
      <li
        class="nav-item"
        >
        <a
          class="nav-link"
          [routerLink]="['/product-upload']"
          >
          Products
        </a>
      </li>
    }
    <li class="nav-item">
      <a
        class="nav-link"
        routerLinkActive="tab-active"
        [routerLink]="['/contact']"
        >
        Contact
      </a>
    </li>
  </ul>
  <div class="d-flex align-items-center me-3">
    @if (lenderHubService.lenderName?.lenderLogoUrl) {
      <img
        class="lender-logo mx-3 logo-plate"
        [class.w-100]="imgIsSvg"
        [src]="lenderHubService.lenderName?.lenderLogoUrl"
        [alt]="lenderHubService.lenderName?.name ?? ''"
        />
    }
    @if (isLoggedIn) {
      <div
        class="feedback-icons"
        >
        <i
          class="far fa-thumbs-up"
          (click)="showFeedbackModal()"
        ></i>
        <i
          class="far fa-thumbs-down"
          (click)="showFeedbackModal()"
        ></i>
      </div>
    }
  </div>
</lib-header>

<ng-template #userFeedbackTemplate>
  <lib-app-user-feedback />
</ng-template>
